module.exports = __webpack_public_path__ + "static/home__our-tech.1dda200f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home__our-tech.jpg
// module id = 508
// module chunks = 35783957827783